import Vue from 'vue'
import Vuex from 'vuex'
import { info } from '@/service/user'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: {},
    },
    mutations: {
        setUserInfo(state, payload) {
            state.userInfo = payload.data
        },
    },
    actions: {
        getUserInfo({commit}) {
            return new Promise((resolve, rej) => {
                info().then(res => {
                    if (res.status) {
                        commit('setUserInfo', {data: res.data})
                        resolve()
                    } else {
                        rej(res.info)
                    }
                }).catch(err => {
                    rej(err)
                })
            })
        }
    }
})
